import { render } from "./ForgotPassFormComponent.vue?vue&type=template&id=f56f6c4a&scoped=true&ts=true"
import script from "./ForgotPassFormComponent.vue?vue&type=script&lang=ts"
export * from "./ForgotPassFormComponent.vue?vue&type=script&lang=ts"

import "./ForgotPassFormComponent.vue?vue&type=style&index=0&id=f56f6c4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56f6c4a"]])

export default __exports__